import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LANDING_GLOBAL_MAP_HEADER = (
    <FormattedMessage
        id='landing_global_map.header'
        defaultMessage='Глобальная карта'
    />
)

export const LANDING_GLOBAL_MAP_MESSAGE1 = (
    <FormattedMessage
        id='landing_global_map.message1'
        // eslint-disable-next-line max-len
        defaultMessage={'Кланы ведут ожесточённую борьбу за территории на игровом поле{nbsp}— Глобальной карте. Выполняя определённые действия, они зарабатывают золото и другие награды.'}
        values={{
            nbsp: <span>&nbsp;</span>,
        }}
    />
)

export const LANDING_GLOBAL_MAP_MESSAGE2 = (
    <FormattedMessage
        id='landing_global_map_message2'
        // eslint-disable-next-line max-len
        defaultMessage={'Также на Глобальной карте проходят игровые события, в которых можно получить технику, особые 3D-стили и многое другое.'}
    />
)


// WEBPACK FOOTER //
// ./containers/Landing/components/LandingGlobalMap/translations.jsx